// #region store enum
export enum DeliveryType {
  Delivery = 0,
  Collection = 1, // This is called 'Pickup' on the server.
}

export enum PickupLocationType {
  TakeOut = 0,
  TableService = 1,
  DineIn = 2,
}

export enum TableServiceCategory {
  Generic = 0,
  Villa = 1,
  House = 2,
  Room = 3,
  Area = 4,
  Table = 5,
  ParkingBay = 6,
  Gate = 7,
  DriveThrough = 8,
}
// #endregion

// #region store types
export interface ConcessionStore {
  ConcessionStoreId: number;
  Description: string;
  ImageName: string;
  ImageUrl: string;
  Name: string;
}
// #endregion

// #region store config types
export interface ServiceChargeConfig {
  AmountExcludingProcessingFee: number | null;
  DisplayAsOneWithProcessingFee: boolean;
  DisplayPercentage: number | null;
  IsEnabled: boolean;
  IsOptional: boolean;
}
// #endregion
